import { ConfigurationCategory } from '../common/enums/configuration-category.enum';

/** this model will be used for all hard-coded configs to be in back-end */
export class KeyValueConfig {
	public id?: string;
	public name?: ConfigurationCategory;
	public key?: string;
	public value?: string;
}
